import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, Shield } from 'lucide-react';
import { Layout } from '../components/Layout';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
export function PaymentSuccess() {
  return <Layout data-id="element-539">
      <div className="max-w-md mx-auto px-4 py-20 text-center" data-id="element-540">
        <div className="inline-flex w-20 h-20 bg-green-100 rounded-full items-center justify-center mb-6" data-id="element-541">
          <CheckCircle2 className="w-10 h-10 text-green-600" data-id="element-542" />
        </div>

        <h1 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-543">
          ¡Pago exitoso!
        </h1>

        <p className="text-gray-500 mb-8" data-id="element-544">
          Los fondos están asegurados en Agreexa. El prestador ha sido
          notificado y puede comenzar a trabajar.
        </p>

        <Card className="mb-8 bg-blue-50/50 border-blue-100" data-id="element-545">
          <div className="flex items-start gap-3" data-id="element-546">
            <Shield className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-547" />
            <div className="text-left" data-id="element-548">
              <h3 className="text-sm font-bold text-gray-900 mb-1" data-id="element-549">
                Fondos protegidos
              </h3>
              <p className="text-xs text-gray-600" data-id="element-550">
                El dinero no se liberará al prestador hasta que confirmes que
                recibiste el servicio acordado.
              </p>
            </div>
          </div>
        </Card>

        <Link to="/" data-id="element-551">
          <Button variant="outline" fullWidth data-id="element-552">
            Volver al inicio
          </Button>
        </Link>
      </div>
    </Layout>;
}